export type ManageEventGroup = "Registration" | "Scoring" | "Financials";

export type ManageEventIcon =
  | "registrations"
  | "entries"
  | "waitlist"
  | "moveups"
  | "scoring"
  | "transactions"
  | "refunds"
  | "discounts"
  | "addons"
  | "incentives";

export interface IManageEventSection {
  id: string;
  label: string;
  tabIndex: number;
  queryAliases: string[];
  group: ManageEventGroup;
  icon: ManageEventIcon;
}

export const MANAGE_EVENT_GROUPS: ManageEventGroup[] = ["Registration", "Scoring", "Financials"];

export const MANAGE_EVENT_SECTIONS: IManageEventSection[] = [
  { id: "registrations", label: "Registrations", tabIndex: 0, queryAliases: ["Registrations", "Registrants"], group: "Registration", icon: "registrations" },
  { id: "entries", label: "Entries / Results", tabIndex: 1, queryAliases: ["Entries / Results", "Results"], group: "Registration", icon: "entries" },
  { id: "waitlist", label: "Waitlist", tabIndex: 5, queryAliases: ["Waitlist"], group: "Registration", icon: "waitlist" },
  { id: "move-ups", label: "Move-Ups", tabIndex: 2, queryAliases: ["Move-Ups"], group: "Scoring", icon: "moveups" },
  { id: "scoring", label: "Scoring", tabIndex: 9, queryAliases: ["Scoring", "Gate Stewards", "GateStewards"], group: "Scoring", icon: "scoring" },
  { id: "transactions", label: "Transactions", tabIndex: 3, queryAliases: ["Transactions"], group: "Financials", icon: "transactions" },
  { id: "refund-requests", label: "Refund Requests", tabIndex: 4, queryAliases: ["Refund Requests"], group: "Financials", icon: "refunds" },
  { id: "discounts", label: "Discounts", tabIndex: 7, queryAliases: ["Discounts"], group: "Financials", icon: "discounts" },
  { id: "add-ons", label: "Add-Ons", tabIndex: 6, queryAliases: ["Add-Ons"], group: "Financials", icon: "addons" },
  { id: "incentives", label: "Incentives", tabIndex: 8, queryAliases: ["Incentives"], group: "Financials", icon: "incentives" },
];

export const MANAGE_EVENT_ENTRIES_TAB_INDEX = MANAGE_EVENT_SECTIONS.find((section) => section.id === "entries")!.tabIndex;

export const getManageEventSectionIndex = (param: string | null | undefined): number | undefined => {
  if (!param) {
    return undefined;
  }

  const match = MANAGE_EVENT_SECTIONS.find((section) => {
    return section.id === param || section.label === param || section.queryAliases.includes(param);
  });

  return match?.tabIndex;
};
